import { customFields } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getCustomFieldsOption(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(customFields.options, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomFieldsList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(customFields.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomFieldsObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customFields.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomFieldsDetail(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customFields.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createCustomFieldsObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customFields.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCustomFieldsObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${customFields.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCustomFieldsObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customFields.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  // For delete 
  deleteCustomFieldsObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${customFields.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  }
});
